export const guests = [
  // https://coolors.co/1d1353-d81159-8f2d56-218380-73d2de
  {
    id: 0,
    name: "Jake Martincic",
    position: "Grant Cardone Licensee",
    title: "",
    subtitle: "",
    speakingDate: "2020-07-27",
    linkedinURL: "https://www.linkedin.com/in/jake-martincic-69354837/",
    photoFileName: "jake-martinicic.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: "",
    presentationPage: "https://www.youtube.com/watch?v=u91mwQXUOfg",
    eventBrite:
      "https://www.eventbrite.com/e/crush-your-quota-w-will-martincic-a-grant-cardone-licensee-tickets-114476833290",
    presentationYT: "",
    previewYT: "",
    presentationAV: "",
    previewAV: "",
    cardColor: "background-color:#1D1353;box-shadow: 2px 10px 15px grey;",
    trimColor: "",
    zoomTracking: "https://calendly.com/rosse/marketing-presentation-prescreen",
  },
  {
    id: 1,
    name: "Christopher Robinson",
    position: "Sales Engineer @ eSign Genie",
    title: "",
    subtitle: "",
    speakingDate: "2020-07-29",
    linkedinURL: "https://www.linkedin.com/in/christopher-robinson-5b960912/",
    photoFileName: "christopher-robinson.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: "",
    presentationPage: "",
    eventBrite:
      "https://www.eventbrite.com/e/crush-your-quota-w-christopher-robin-esign-genie-tickets-114378948514",
    presentationYT: "",
    previewYT: "",
    presentationAV: "",
    previewAV: "",
    cardColor: "background-color:#221764;box-shadow: 2px 10px 15px grey;",
    trimColor: "",
    zoomTracking: "https://calendly.com/rosse/marketing-presentation-prescreen",
  },
  {
    id: 2,
    name: "Dave Kerpen",
    position: "Entrepreneurs’ Organization",
    title: "",
    subtitle: "",
    speakingDate: "2020-08-13",
    linkedinURL: "https://www.linkedin.com/in/davekerpen/",
    photoFileName: "dave-kerpen.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: "",
    presentationPage: "",
    eventBrite: "",
    presentationYT: "",
    previewYT: "",
    presentationAV: "",
    previewAV: "",
    cardColor: "background-color:#281A74;box-shadow: 2px 10px 15px grey;",
    trimColor: "",
    zoomTracking: "https://calendly.com/rosse/marketing-presentation-prescreen",
  },
  {
    id: 3,
    name: "Andrew Carroll",
    position: "Relationship Manager at Pivotal Clean @ Pivotal Clean",
    title: "",
    subtitle: "",
    speakingDate: "",
    linkedinURL: "https://www.linkedin.com/in/andrew-carroll-19a69431/",
    photoFileName: "andrew-carroll.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: "",
    presentationPage: "",
    eventBrite:
      "https://www.eventbrite.com/e/crush-your-quota-w-christopher-robinson-esign-genie-tickets-114378948514",
    presentationYT: "",
    previewYT: "",
    presentationAV: "",
    previewAV: "",
    cardColor: "background-color:#332296;box-shadow: 2px 10px 15px grey;",
    trimColor: "",
    zoomTracking: "https://calendly.com/rosse/marketing-presentation-prescreen",
  },
  {
    id: 4,
    name: "Jake Bernshtein",
    position: "Director of Sales @ Clearcut Analytics",
    title: "",
    subtitle: "",
    speakingDate: "2020-07-28",
    linkedinURL: "https://www.linkedin.com/in/jakebernstein21/",
    photoFileName: "jake-bernshtein.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: "",
    presentationPage: "https://www.youtube.com/watch?v=neKKhE0Pht8",
    eventBrite: "",
    presentationYT: "",
    previewYT: "",
    presentationAV: "",
    previewAV: "",
    cardColor: "background-color:#281A74;box-shadow: 2px 10px 15px grey;",
    trimColor: "",
    zoomTracking: "https://calendly.com/rosse/marketing-presentation-prescreen",
  },
  {
    id: 5,
    name: "Elliot Carney",
    position: "Enterprise Sales Director @ inVia Robotics",
    title: "",
    subtitle: "",
    speakingDate: "2020-08-03",
    linkedinURL: "hhttps://www.linkedin.com/in/elliotcarney/",
    photoFileName: "elliot-carney.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: "",
    presentationPage: "",
    eventBrite: "",
    presentationYT: "",
    previewYT: "",
    presentationAV: "",
    previewAV: "",
    cardColor: "background-color:#3926A6;box-shadow: 2px 10px 15px grey;",
    trimColor: "",
    zoomTracking: "https://calendly.com/rosse/marketing-presentation-prescreen",
  },
  {
    id: 6,
    name: "D'Joane H.McCorkle",
    position: "Business Development Consultant @ DHM Enterprises",
    title: "",
    subtitle: "",
    speakingDate: "2020-08-19",
    linkedinURL: "https://www.linkedin.com/in/djoanemccorkle/",
    photoFileName: "DJoane_H.McCorkle.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    speakerPage: "",
    presentationPage: "",
    eventBrite: "",
    presentationYT: "",
    previewYT: "",
    presentationAV: "",
    previewAV: "",
    cardColor: "background-color:#3F2AB7;box-shadow: 2px 10px 15px grey;",
    trimColor: "",
    zoomTracking: "https://calendly.com/rosse/marketing-presentation-prescreen",
  },

  // {
  //   id: 2,
  //   name: 'Your Name Here',
  //   position: 'Sales Lead / Top Performer',
  //   title: 'Apply to speak - Season premiers July 20th',
  //   subtitle: '',
  //   speakingDate: '2020-07-20',
  //   linkedinURL: '',
  //   photoFileName: 'question-man.jpg',
  //   datePretty: '',
  //   daysLeft: 1,
  //   speakerStatus: 2,
  //   speakerPage: '',
  //   presentationPage: '',
  //   eventBrite: '',
  //   presentationYT: '',
  //   previewYT: '',
  //   presentationAV: '',
  //   previewAV:'',
  //   cardColor: 'background-color:#160F40;box-shadow: 2px 10px 15px grey;',
  //   trimColor: '',
  //   zoomTracking: 'https://calendly.com/rosse/marketing-presentation-prescreen'
  // },
  // {
  //   id: 3,
  //   name: 'Your Name Here',
  //   position: 'Sales Lead / Top Performer',
  //   title: 'Apply to speak - Season premiers July 20th',
  //   subtitle: '',
  //   speakingDate: '2020-07-20',
  //   linkedinURL: '',
  //   photoFileName: 'question-man.jpg',
  //   datePretty: '',
  //   daysLeft: 1,
  //   speakerStatus: 2,
  //   speakerPage: '',
  //   presentationPage: '',
  //   eventBrite: '',
  //   presentationYT: '',
  //   previewYT: '',
  //   presentationAV: '',
  //   previewAV:'',
  //   cardColor: 'background-color:#160F40;box-shadow: 2px 10px 15px grey;',
  //   trimColor: '',
  //   zoomTracking: 'https://calendly.com/rosse/marketing-presentation-prescreen'
  // },

  // {
  //   id: 26,
  //   // Required
  //   name: 'Andrea Freyrear',
  //   position: 'Agile Marketing Coach & Trainer @ AgileSherpas',
  //   title: 'Agile Marketing for the Win',
  //   speakingDate: '2020-06-01',
  //   linkedinURL: 'https://www.linkedin.com/in/afryrear/',
  //   photoFileName: 'andrea_fryrear.jpeg',
  //   zoomTracking: 'https://zoom.us/webinar/register/5615901563760/WN_amII22BgS2C0_NlExIbqFw'
  //   // Need All for Signup Page
  //   speakerPage: '',
  //   previewYT: '',
  //   eventBrite: '',
  //   previewAV:'',
  //   // SKIP (Program will set these)
  //   cardColor: 'background-color:white;box-shadow: 2px 10px 15px grey;',
  //   trimColor: '',
  //   datePretty: '',
  //   daysLeft: 1,
  //   speakerStatus: 2,
  //   subtitle: '',
  //   // Post Presentation Optional
  //   presentationPage: '',
  //   presentationYT: '',
  //   presentationAV: '',
  // }
];

export const yourDataGuys = [
  {
    id: 0,
    name: "Ross Gates",
    position: "Co-Founder & Product Manager @ Gravity",
    title: "Buying intent signal consultant & data driven product designer",
    subtitle: "",
    speakingDate: "",
    linkedinURL: "https://www.linkedin.com/in/rossegates/",
    photoFileName: "ross.jpeg",
    datePretty: "",
    daysLeft: 0,
    speakerStatus: 0,
    cardColor: "background-color:#7913F6;box-shadow: 2px 10px 15px grey;",
  },
  {
    id: 1,
    name: "Bryan Colligan",
    position: "Co-Founder & CTO @ Gravity",
    title: "3x Founder, Growth Hacker & Marketer",
    subtitle: "",
    speakingDate: "",
    linkedinURL: "https://www.linkedin.com/in/bryancolligan/",
    photoFileName: "bryan-purple.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    cardColor: "background-color:#6F09EC;box-shadow: 2px 10px 15px grey;",
  },
];

export const yourSalesGurus = [
  {
    id: 0,
    name: "Will Fuentes",
    position: "Sales Acceleration Consultant @ MaestroGroup",
    title:
      "Auditing and improving - sales leadership and culture, systems and analytics, and the sales team itself",
    subtitle: "",
    speakingDate: "",
    linkedinURL: "https://www.linkedin.com/in/will-fuentes-drivefastersales/",
    photoFileName: "will-fuentes-2.jpg",
    datePretty: "",
    daysLeft: 0,
    speakerStatus: 0,
    cardColor: "background-color:#5E7EE8;box-shadow: 2px 10px 15px grey;",
  },
  {
    id: 1,
    name: "Patrick Hudgins",
    position: "CEO @ Delegate",
    title:
      "Helping fast-moving companies make sense of their sales, marketing, & cs systems",
    subtitle: "",
    speakingDate: "",
    linkedinURL: "https://www.linkedin.com/in/patrickhudgins/",
    photoFileName: "patrick-hudgins.jpeg",
    datePretty: "",
    daysLeft: 0,
    speakerStatus: 0,
    cardColor: "background-color:#4C70E6;box-shadow: 2px 10px 15px grey;",
  },
  {
    id: 2,
    name: "Tom Melbourne",
    position: "Head of Sales Strategy and Operations @ RiSE Accelerator",
    title: "13 years in Sales Management",
    subtitle: "",
    speakingDate: "",
    linkedinURL: "https://www.linkedin.com/in/tommelbourne/",
    photoFileName: "tom-melbourne.jpeg",
    datePretty: "",
    daysLeft: 1,
    speakerStatus: 2,
    cardColor: "background-color:#3B62E3;box-shadow: 2px 10px 15px grey;",
  },
  {
    id: 3,
    name: "Taariq Lewis",
    position: "CEO & Co-Founder @ Promise",
    title: "Repeat creator sales courses of Udemy",
    subtitle: "",
    speakingDate: "",
    linkedinURL: "https://www.linkedin.com/in/taariq/",
    photoFileName: "taariq-lewis.jpeg",
    datePretty: "",
    daysLeft: 0,
    speakerStatus: 0,
    cardColor: "background-color:#2954E0;box-shadow: 2px 10px 15px grey;",
  },

  //   {
  //     id: 3,
  //     name: 'Bryan Colligan',
  //     position: 'Co-Founder & CTO @ Gravity',
  //     title: '3x Founder, Growth Hacker & Marketer',
  //     subtitle: '',
  //     speakingDate: '',
  //     linkedinURL: 'https://www.linkedin.com/in/bryancolligan/',
  //     photoFileName: 'bryan-purple.jpeg',
  //     datePretty: '',
  //     daysLeft: 1,
  //     speakerStatus: 2,
  //     cardColor: 'background-color:#1D45CD;box-shadow: 2px 10px 15px grey;',
  //   }
];

// 5D48D5
